module.exports = __webpack_public_path__ + "img/investment-approach.d67a3eee.jpg";